import { useEffect } from "react";
import { normalizeLanguage } from "../utils/locale";

const APP_ORIGIN = "https://app.linkedscope.com";
const LANGUAGES = ["pt", "en", "es"];

export default function useAuthPageMetadata(pathname, language, description) {
  useEffect(() => {
    const cleanups = [];
    const setTag = (selector, tagName, attributes) => {
      const existing = document.head.querySelector(selector);
      const element = existing || document.createElement(tagName);
      const previous = Object.fromEntries(
        Object.keys(attributes).map(key => [key, element.getAttribute(key)])
      );
      Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
      if (!existing) document.head.appendChild(element);
      cleanups.push(() => {
        if (!existing) {
          element.remove();
          return;
        }
        Object.entries(previous).forEach(([key, value]) => {
          if (value === null) element.removeAttribute(key);
          else element.setAttribute(key, value);
        });
      });
    };

    const canonical = `${APP_ORIGIN}${pathname}?lang=${normalizeLanguage(language)}`;
    setTag('meta[name="description"]', "meta", { name: "description", content: description });
    setTag('link[rel="canonical"]', "link", { rel: "canonical", href: canonical });
    LANGUAGES.forEach(lang => {
      setTag(`link[rel="alternate"][hreflang="${lang}"]`, "link", {
        rel: "alternate", hreflang: lang, href: `${APP_ORIGIN}${pathname}?lang=${lang}`,
      });
    });
    setTag('link[rel="alternate"][hreflang="x-default"]', "link", {
      rel: "alternate", hreflang: "x-default", href: `${APP_ORIGIN}${pathname}`,
    });

    return () => cleanups.reverse().forEach(cleanup => cleanup());
  }, [pathname, language, description]);
}
